var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdentificationCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.75 7.5H6.25C5.91848 7.5 5.60054 7.6317 5.36612 7.86612C5.1317 8.10054 5 8.41848 5 8.75V31.25C5 31.5815 5.1317 31.8995 5.36612 32.1339C5.60054 32.3683 5.91848 32.5 6.25 32.5H33.75C34.0815 32.5 34.3995 32.3683 34.6339 32.1339C34.8683 31.8995 35 31.5815 35 31.25V8.75C35 8.41848 34.8683 8.10054 34.6339 7.86612C34.3995 7.6317 34.0815 7.5 33.75 7.5ZM14.3907 22.5C13.649 22.5 12.924 22.2801 12.3073 21.868C11.6906 21.456 11.21 20.8703 10.9261 20.1851C10.6423 19.4998 10.5681 18.7458 10.7128 18.0184C10.8574 17.291 11.2146 16.6228 11.739 16.0983C12.2635 15.5739 12.9317 15.2167 13.6591 15.0721C14.3865 14.9274 15.1405 15.0016 15.8258 15.2855C16.511 15.5693 17.0967 16.0499 17.5087 16.6666C17.9208 17.2833 18.1407 18.0083 18.1407 18.75C18.1407 19.2425 18.0437 19.7301 17.8552 20.1851C17.6668 20.64 17.3906 21.0534 17.0423 21.4017C16.6941 21.7499 16.2807 22.0261 15.8258 22.2146C15.3708 22.403 14.8832 22.5 14.3907 22.5Z",
    fill: "#E34444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 17.5H30",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 22.5H30",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3906 22.5C16.4617 22.5 18.1406 20.8211 18.1406 18.75C18.1406 16.6789 16.4617 15 14.3906 15C12.3196 15 10.6406 16.6789 10.6406 18.75C10.6406 20.8211 12.3196 22.5 14.3906 22.5Z",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5481 26.2499C9.82553 25.1766 10.4517 24.2259 11.3282 23.5471C12.2046 22.8684 13.2818 22.5 14.3904 22.5C15.499 22.5 16.5761 22.8682 17.4527 23.5469C18.3292 24.2256 18.9554 25.1763 19.2329 26.2496",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 7.5H6.25C5.55964 7.5 5 8.05964 5 8.75V31.25C5 31.9404 5.55964 32.5 6.25 32.5H33.75C34.4404 32.5 35 31.9404 35 31.25V8.75C35 8.05964 34.4404 7.5 33.75 7.5Z",
    stroke: "#E34444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationCard);
export default __webpack_public_path__ + "static/media/IdentificationCard.7814e6c2a1ceddddd23beb49de571dcc.svg";
export { ForwardRef as ReactComponent };